export default "__VITE_ASSET__a05c6ea3__"